var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"RightBottomContainer d-flex"},[_c('div',{staticClass:"imgBox"},[_c('img',{attrs:{"src":require("@/assets/sportFacilities/alarm.png"),"alt":""}})]),_c('div',{staticClass:"alarmTitle"},[_vm._v("黑榜预警系统")])])
}]

export { render, staticRenderFns }